import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useDarkMode } from '../../context/DarkModeContext';
import { IconButton } from '@mui/material';

function DarkModeToggle({ fill }) {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <IconButton
      onClick={toggleDarkMode}
      size="small"
      sx={{
        color: '#FFFBEB',
        borderRadius: 999,
        '&:hover': {
          backgroundColor: 'rgba(15,23,42,0.12)',
        },
      }}
    >
      {isDarkMode ? (
        <LightModeIcon sx={{ color: '#FFEB3B' }}
          fontSize="small" />
      ) : (
        <DarkModeOutlinedIcon
          sx={{ color: fill || '#1E88E5' }}
          fontSize="small"
        />
      )}
    </IconButton>
  );
}

export default DarkModeToggle;
